import React from "react"
import "./index.scss"
import {observer} from "mobx-react-lite"
import Tooltip from "@material-ui/core/Tooltip"
import {makeStyles} from "@material-ui/core/styles"
import {UseStores} from "../../hooks/UseStores"
import MenuItem from "@material-ui/core/MenuItem"
import FormControl from "@material-ui/core/FormControl"
import Select from "@material-ui/core/Select"
import {noOfdaysFromCurrentDate} from "../../utils/utils"
import {GET_LAST_VISIT_PROCESSED_DATE} from "../../gql/gqlLastVisits"
import {useQuery} from "graphql-hooks"

const styles = {
  arrow: {
    "&:before": {
      border: "1px solid #E6E8ED",
    },
    color: "#FFF",
  },
  tooltip: {
    backgroundColor: "#FFF",
    border: "1px solid #E6E8ED",
    color: "#4A4A4A",
    fontSize: 12,
    width: 97,
    padding: 10,
    textAlign: "center",
  },
  selectRoot: {
    fontSize: "var(--font-size-paragraph-large)",
    height: "18px",
  },
  icon: {
    color: "var(--modes-on-primary-container)",
    right: "6px",
  },
  ul: {
    paddingLeft: "8px",
    paddingRight: "8px",
    minWidth: "182px !important",
  },
  select: {
    fontSize: "var(--font-size-paragraph-large)",
    fontFamily: "var(--primary-font-family)",
    fontWeight: "var(--font-weight-regular)",
    color: "var(--modes-on-primary-container)",
    padding: "12px",
    borderRadius: "var(--border-radius)",
    border: "1px solid var(--modes-primary)",
    background: "var(--modes-primary-container)",
    width: "160px",
    "&:hover": {
      border: "1px solid var(--color-link)",
    },
    "&:focus": {
      background: "var(--modes-primary-container)",
      borderRadius: "var(--border-radius)",
    },
  },
  menuItem: {
    fontSize: "var(--font-size-paragraph-large)",
    fontFamily: "var(--primary-font-family)",
    fontWeight: "var(--font-weight-regular)",
    lineHeight: "var(--line-height)",
    color: "var(--modes-on-primary-container)",
    padding: "8px",
    marginBottom: "4px",
    "&:hover": {
      backgroundColor: "var(--modes-primary-container)",
      borderRadius: "2px",
    },
    "&:last-child": {
      marginBottom: "0px",
    },
    "&.Mui-selected": {
      backgroundColor: "var(--modes-primary)",
      fontWeight: "var(--font-weight-bold)",
      borderRadius: "2px",
      "&:hover": {
        backgroundColor: "var(--modes-primary)",
      },
    },
  },
}
let useStyles = makeStyles((theme) => styles)
let infoIconText = ""

const DaysDropDown = () => {
  let styleChangeForError = () => {
    let tooltip = {
      backgroundColor: "#FFF",
      border: "1px solid #E6E8ED",
      color: "#4A4A4A",
      fontSize: 12,
      width: 150,
      padding: 10,
      textAlign: "center",
    }
    useStyles = makeStyles((theme) => ({...styles, tooltip}))
  }
  const {loading, error, data} = useQuery(GET_LAST_VISIT_PROCESSED_DATE)
  if (loading) {
    infoIconText = "Loading..."
  }
  if (error) {
    styleChangeForError()
    infoIconText = `We have connection issues, please try later.`
  }
  if (data && data.getLastVisitProcessedDate) {
    infoIconText = `Data is delayed about ${noOfdaysFromCurrentDate(
      data.getLastVisitProcessedDate
    )} days`
  }
  const classes = useStyles()
  const {timePeriodStore, locGroupStore, disStore} = UseStores()
  const mapForDays = new Map([
    ["SEVEN_DAYS", "7"],
    ["FOURTEEN_DAYS", "14"],
    ["THIRTY_DAYS", "30"],
    ["FORTY_FIVE_DAYS", "45"],
    ["SIXTY_DAYS", "60"],
    ["NINETY_DAYS", "90"],
  ])
  const getKeyByValue = (searchValue) => {
    for (let [key, value] of mapForDays.entries()) {
      if (value === searchValue) return key
    }
  }
  const value = mapForDays.get(timePeriodStore.timePeriod)

  const valueArr = []
  const mapValues = mapForDays.values()
  for (let val of mapValues) {
    valueArr.push(val)
  }

  const handleOptionClick = (item) => {
    let timePeriod = getKeyByValue(item)
    timePeriod && timePeriodStore.setTimePeriod(timePeriod)
    timePeriod && disStore.setGeoTimeObj({timePeriod: timePeriod})
    timePeriod && locGroupStore.setLocGeoTime({timePeriod: timePeriod})
    if (timePeriod) {
      disStore.setGeoServiceObj({timePeriod: timePeriod})
      locGroupStore.setGeoServiceObj({timePeriod: timePeriod})
    }
  }

  let domSelectBox = (
    <FormControl variant="outlined" size="small">
      <Select
        classes={{root: classes.selectRoot, icon: classes.icon, select: classes.select}}
        variant="standard"
        disableUnderline={true}
        onChange={(event) => {
          handleOptionClick(event.target.value)
        }}
        value={value}
        MenuProps={{
          classes: {paper: classes.ul},
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "left",
          },
          getContentAnchorEl: null,
        }}
      >
        {valueArr.map((menuItem, index) => {
          return (
            <MenuItem
              key={index}
              value={menuItem}
              classes={{root: classes.menuItem}}
            >{`Last ${menuItem} days`}</MenuItem>
          )
        })}
      </Select>
    </FormControl>
  )

  return (
    <div data-testid="dropdown-container" className="dropdown-info-container">
      {domSelectBox}
      <div className="info-container">
        <Tooltip
          title={infoIconText}
          arrow
          placement="bottom-end"
          classes={{arrow: classes.arrow, tooltip: classes.tooltip}}
        >
          <span className="info-circle-button"></span>
        </Tooltip>
      </div>
    </div>
  )
}
export default observer(DaysDropDown)
